class Toggle {
    constructor(id, context) {
        this.listeners = {};

        this.el = this.getElement(id);
        this.triggers = $$(`[data-toggle="${id}"]`, context);
        this.visible = this.el.getAttribute('aria-hidden') === 'false';

        this.triggers.forEach((btn) => {
            btn.setAttribute('aria-controls', id);
            btn.setAttribute('aria-expanded', this.visible);
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggle();
            }, false);
        });

        this.el.setAttribute('aria-hidden', !this.visible);
    }

    on(type, handler) {
        if (typeof this.listeners[type] === 'undefined') {
            this.listeners[type] = [];
        }
        this.listeners[type].push(handler);
    }

    off(type, handler) {
        if (typeof handler === 'undefined') {
            delete this.listeners[type];
            return;
        }

        const handlers = this.listeners[type].filter(fn => fn !== handler);
        this.listeners[type] = handlers;
    }

    emit(type, ...args) {
        const handlers = this.listeners[type] || [];
        handlers.forEach(fn => fn.call(null, ...args));
    }

    isVisible() {
        return this.el.getAttribute('aria-hidden') === 'false';
    }

    toggle(state, msg = null) {
        const expand = typeof state === 'undefined' ? !this.visible : state;
        const action = expand ? 'expand' : 'collapse';

        this.el.setAttribute('aria-hidden', !expand);
        this.triggers.forEach(btn => btn.setAttribute('aria-expanded', expand));
        this.visible = expand;

        this.emit(action, this.el, this.triggers, msg);
    }

    getElement(id) {
        let el = document.getElementById(id);

        if (!el) {
            console.warn(`No element with id of "${id}" could be found`);
            // Make Toggle fail "silent"
            el = document.createElement('div');
            el.id = id;
        }

        return el;
    }
}

function $$(selector, context = document) {
    const elements = context.querySelectorAll(selector);
    return Array.prototype.slice.call(elements, 0);
}

function toggle(id, context) {
    const toggleElement = new Toggle(id, context);

    return {
        visible: toggleElement.visible,
        isVisible() {
            return toggleElement.isVisible();
        },
        toggle() {
            toggleElement.toggle();
        },
        expand(msg = null) {
            toggleElement.toggle(true, msg);
        },
        collapse(msg = null) {
            toggleElement.toggle(false, msg);
        },
        on(type, handler) {
            toggleElement.on(type, handler);
        },
        off(type, handler) {
            toggleElement.off(type, handler);
        }
    };
}
